import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss'],
})

export class ChartsComponent implements OnInit, OnChanges {
  @Input()chartData: [];
  @Input() chartSeries: [];
  ngOnInit() {
  }

  options: EChartsOption = {
    legend: {},
    tooltip: {},
    dataset: {
      // Provide a set of data.
      source: []
    },

    // Declare an x-axis (category axis).
    // The category map the first column in the dataset by default.
    xAxis: { type: 'category' },
    // Declare a y-axis (value axis).
    yAxis: {type:'value',minInterval:1},
    // Declare several 'bar' series,
    // every series will auto-map to each column by default.
    series: [],
  };

  mergeOptions: EChartsOption;

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.chartData?.currentValue != changes.chartData?.previousValue){
      this.options.dataset['source'] =  changes.chartData.currentValue;
      this.options = {...this.options};
    }
    if(changes.chartSeries?.currentValue != changes.chartSeries?.previousValue){
      this.options.series = changes.chartSeries.currentValue;
      this.options = {...this.options};
    }
  }

}
